export * from "./responsiveTypography";
export * from "./legacyBreakpoints";
//# sourceMappingURL=index.js.map